/* 🎨 STYLES */
import { Container, StyledOption } from "./styles";

const SelectEquipment = ({ options, value, onChange, Color}) => {
    return(
        <Container color={Color} value={value ? value : options[0]} onChange={onChange}>
            {options ? options.map((option, index) => (
                <StyledOption color={Color} key={index} value={option.id}>
                    {option.nome ? option.nome : option.id}
                </StyledOption>
            )) : <></>}
        </Container>
    )
}

export default SelectEquipment;